export default "__VITE_ASSET__21365776__"